<template>
  <header class="material-header z-20">

    <!-- ═══ СТРОКА 1: Логотип | Навигация верхнего уровня (центр) | Аккаунт ═══ -->
    <!-- Ширина синхронизирована с .container (tailwind.config.js → theme.container.screens):
         1280 на xl, 1536 на 2xl. Иначе хедер шире контента и логотип уезжает за край колонок. -->
    <div
        class="top-row max-w-7xl 2xl:max-w-[1536px] mx-auto px-4 py-2 xl:py-1 grid grid-cols-[auto_1fr_auto] items-center gap-4">

      <!-- Логотип (левый столбец) -->
      <div class="flex items-center justify-center">
        <!-- Логотип -->
        <router-link :to="routePath('HOME', '/')" class="flex relative flex-col items-center cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg p-2">
          <img src="/logo.png?v=1" alt="Logo" title="Logo"
               class="rounded-md w-28 xl:w-24 h-auto"/>

          <!-- Компактная плашка ОБТ ТЕСТ + Вопросик -->
          <div class="flex absolute bottom-0 right-1 gap-1.5 text-[10px] font-bold">
            <div class="px-1.5 py-0.25 rounded uppercase tracking-wider bg-amber-500/10 text-amber-500 border border-amber-500/30">
              ОБТ ТЕСТ
            </div>
            <div
                class="w-4 h-4 rounded-full bg-amber-500 text-white flex items-center justify-center cursor-help shadow-sm transition-transform hover:scale-110"
                title="Открытое бета-тестирование: сервис работает в тестовом режиме, возможны доработки"
            >
              ?
            </div>
          </div>
        </router-link>
      </div>

      <!-- Центр: Правила + Новости + Группы -->
      <ul class="hidden md:flex flex-row items-center justify-self-center gap-1">
        <li>
          <router-link :to="routePath('RULES', '/rules')" class="top-nav-link" @click="closeMenu">
            <span>Правила</span>
          </router-link>
        </li>
        <li>
          <router-link :to="routePath('NEWS', '/news')" class="top-nav-link" @click="closeMenu">
            <span>Новости</span>
          </router-link>
        </li>
        <li>
          <router-link :to="routePath('GROUPS', '/groups')" class="top-nav-link" @click="closeMenu">
            <span>Группы</span>
          </router-link>
        </li>
      </ul>

      <!-- Правый столбец: иконки + кнопка меню + nav -->
      <div class="flex items-center justify-self-end gap-1">
        <div class="flex items-center gap-1">
          <router-link
              :to="routes.SUPPORT.path"
              title="Поддержка"
              class="header-icon mr-5 bg-gray-50 dark:bg-gray-700 relative"
          >
            <i class="mdi mdi-headset text-2xl"></i>
            <span v-if="supportUnreadCount > 0" class="notification-badge">{{ supportUnreadCount }}</span>
          </router-link>
          <router-link v-if="authStore.isAuthenticated"
                       :to="routePath('FAVORITES', '/profile/favorites')"
                       class="header-icon" title="Избранное">
            <FavoritesSvg/>
          </router-link>

          <router-link v-if="authStore.isAuthenticated && CHAT_ENABLED"
                       :to="routePath('PROFILE_CHAT', '/profile/chat')"
                       class="header-icon" title="Чат">
            <ChatIconWithBadge/>
          </router-link>

          <button v-if="authStore.isAuthenticated" class="header-icon relative"
                  title="Уведомления" @click="showNotificationModal = true">
            <NotificationIcon class="icon-svg"/>
            <span v-if="unreadCount > 0" class="notification-badge">{{ unreadCount }}</span>
          </button>

        </div>

        <button @click="toggleMenu" class="menu-button md:hidden">
          <svg class="w-6 h-6 text-gray-800 dark:text-gray-200" fill="currentColor" viewBox="0 0 24 24">
            <path stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                  d="M4 6h16M4 12h16m-7 6h7"></path>
          </svg>
        </button>

        <nav :class="['menu', isMenuOpen ? 'menu-open' : '']">
          <div v-if="isMenuOpen" class="flex items-center justify-end space-x-4">
            <button class="theme-toggle-button p-2 rounded-full bg-gray-50 dark:bg-gray-800
                           hover:bg-gray-100 dark:hover:bg-gray-700 focus:ring-2 focus:ring-indigo-400"
                    @click="toggleTheme">
              <ThemeToggle :isDark="themeStore?.isDark" @toggle="toggleTheme"/>
            </button>

            <button v-if="isMenuOpen" @click="closeMenu"
                    class="close-button p-2 rounded-full bg-gray-50 dark:bg-gray-800
                           hover:bg-gray-100 dark:hover:bg-gray-700 focus:ring-2 focus:ring-indigo-400">
              <svg class="w-6 h-6 text-gray-800 dark:text-gray-200" fill="currentColor" viewBox="0 0 24 24">
                <path stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                      d="M6 18L18 6M6 6l12 12"></path>
              </svg>
            </button>
          </div>

          <div class="flex flex-col items-center space-x-2">
            <ul class="flex flex-col md:flex-row md:items-center space-y-2 font-medium text-gray-700 dark:text-gray-300">
              <li>
                <!-- Мобильное меню: все пункты -->
                <ul class="flex flex-col md:hidden">
                  <li>
                    <router-link :to="routePath('RULES', '/rules')" class="menu-link" @click="closeMenu">Правила
                    </router-link>
                  </li>
                  <li>
                    <router-link :to="routePath('NEWS', '/news')" class="menu-link" @click="closeMenu">Новости
                    </router-link>
                  </li>
                  <li>
                    <router-link :to="routePath('GROUPS', '/groups')" class="menu-link" @click="closeMenu">Группы
                    </router-link>
                  </li>
                  <li>
                    <router-link :to="routePath('VACANCIES', '/vacancy')" class="menu-link" @click="closeMenu">
                      Вакансии
                    </router-link>
                  </li>
                  <li>
                    <router-link :to="routePath('RESUMES', '/resume')" class="menu-link" @click="closeMenu">Резюме
                    </router-link>
                  </li>
                  <li>
                    <router-link :to="routePath('OFFERINGS', '/offering')" class="menu-link" @click="closeMenu">Услуги
                    </router-link>
                  </li>
                  <li>
                    <router-link :to="routePath('REALTY', '/realty')" class="menu-link" @click="closeMenu">
                      Недвижимость
                    </router-link>
                  </li>
                  <li>
                    <router-link :to="routePath('PRODUCTS', '/product')" class="menu-link" @click="closeMenu">Товары
                    </router-link>
                  </li>
                  <li>
                    <router-link :to="routePath('QUICK_POST_LIST', '/quick-posts')" class="menu-link" @click="closeMenu">
                      Быстрые объявления
                    </router-link>
                  </li>
                </ul>
              </li>

              <!-- Десктоп: выпадающее меню «Управление» -->
              <li v-if="authStore.hasRole(['admin'])" class="relative hidden md:block"
                  @mouseover="showMenu('management')"
                  @mouseleave="hideMenu('management')">
                <a class="nav-link cursor-default block py-4 xl:py-2 px-4 hover:bg-gray-100 dark:hover:bg-gray-700">
                  Управление
                </a>
                <ul ref="managementMenu"
                    :class="[
                      'absolute bg-white dark:bg-gray-800 shadow-lg rounded mt-0 w-48',
                      'transition-opacity duration-300 z-10 overflow-auto',
                      menuVisibility['management'] ? 'block' : 'hidden',
                    ]"
                    @mouseleave="hideMenu('management')">
                  <li>
                    <router-link :to="routePath('MESSENGERS', '/messenger')" class="menu-link" @click="closeMenu">
                      <span>Мессенджеры</span>
                    </router-link>
                  </li>
                  <li>
                    <router-link :to="routePath('MODERATION', '/moderation')" class="menu-link" @click="closeMenu">
                      <span>Объявления на проверке</span>
                    </router-link>
                  </li>
                </ul>
              </li>

              <!-- Мобильная версия «Управление» -->
              <li v-if="authStore.hasRole(['admin'])" class="md:hidden">
                <ul class="flex flex-col">
                  <li class="px-4 py-2 text-sm text-gray-500 dark:text-gray-400 font-medium">Управление</li>
                  <li>
                    <router-link :to="routePath('MESSENGERS', '/messenger')" class="menu-link" @click="closeMenu">
                      <span>Мессенджеры</span>
                    </router-link>
                  </li>
                  <li>
                    <router-link :to="routePath('MODERATION', '/moderation')" class="menu-link" @click="closeMenu">
                      <span>Объявления на проверке</span>
                    </router-link>
                  </li>
                </ul>
              </li>

              <!-- Аккаунт (десктоп: выпадающее, мобайл: flat) -->
              <li class="relative xl:mr-2" @mouseover="showMenu('account')" @mouseleave="hideMenu('account')">
                <span class="cursor-default block py-4 xl:py-2 px-2 border-2 border-purple-800 rounded-xl duration-200">
                  {{ authStore.isAuthenticated && userStore.getUserName ? userStore.getUserName : 'Аккаунт' }}
                </span>

                <ul ref="accountMenu"
                    :class="[
                      'absolute bg-white dark:bg-gray-800 shadow-lg rounded mt-0 w-64',
                      'transition-opacity duration-300 z-10 overflow-auto',
                      menuVisibility['account'] ? 'block' : 'hidden',
                    ]"
                    @mouseleave="hideMenu('account')">
                  <li v-if="!authStore.isAuthenticated">
                    <router-link :to="routePath('LOGIN', '/login')" class="menu-link" @click="closeMenu">
                      <span>Вход</span>
                    </router-link>
                  </li>
                  <li v-if="!authStore.isAuthenticated">
                    <router-link :to="routePath('REGISTRATION', '/registration')" class="menu-link" @click="closeMenu">
                      <span>Регистрация</span>
                    </router-link>
                  </li>
                  <li v-if="!authStore.isAuthenticated">
                    <router-link :to="routePath('RESTORE_PASSWORD', '/restore-password')" class="menu-link"
                                 @click="closeMenu">
                      <span>Восстановление пароля</span>
                    </router-link>
                  </li>
                  <li v-if="authStore.isAuthenticated">
                    <router-link :to="routePath('PROFILE', '/profile')" class="menu-link" @click="closeMenu">
                      <ProfileSvg/>
                      <span class="ml-2">Личный кабинет</span>
                    </router-link>
                  </li>
                  <li v-if="authStore.isAuthenticated">
                    <router-link :to="myOfferingsRoute" class="menu-link" @click="closeMenu">
                      <span>Мои объявления</span>
                    </router-link>
                  </li>
                  <li v-if="authStore.isAuthenticated">
                    <router-link :to="myProductsRoute" class="menu-link" @click="closeMenu">
                      <span>Мои товары</span>
                    </router-link>
                  </li>
                  <li>
                    <button class="menu-link" @click="toggleTheme">
                      <ThemeToggle :isDark="themeStore?.isDark" @toggle="toggleTheme"/>
                      <span class="ml-2">{{ themeStore.isDark ? 'Светлая тема' : 'Темная тема' }}</span>
                    </button>
                  </li>
                  <li>
                    <router-link v-if="authStore.isAuthenticated" :to="routePath('HOME', '/')" class="menu-link"
                                 @click="logout">
                      <ExitSvg/>
                      <span class="ml-2">Выход</span>
                    </router-link>
                  </li>
                </ul>
              </li>

              <li v-if="authStore.isAuthenticated" class="relative">
                <router-link :to="routePath('CREATE_AD', '/create-ad')" @click="closeMenu">
                  <span class="block py-4 xl:py-2 px-2 bg-green-600 hover:bg-green-700 focus:ring-green-500
                               text-white text-nowrap font-bold dark:text-green-100 rounded-xl
                               transition-colors duration-200">
                    Разместить объявление
                  </span>
                </router-link>
              </li>

              <li class="relative hidden md:flex items-center">
                <router-link :to="routePath('ONBOARDING', '/onboarding')" @click="closeMenu"
                             class="onboarding-btn" title="Знакомство с Буйян">
                  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="12" r="11" fill="#16a34a"/>
                    <rect x="11" y="6" width="2" height="7" rx="1" fill="white"/>
                    <rect x="11" y="15.5" width="2" height="2.5" rx="1" fill="white"/>
                  </svg>
                </router-link>
              </li>

            </ul>
          </div>
        </nav>

        <div v-if="isMenuOpen" class="menu-overlay fixed inset-0 bg-black bg-opacity-50 z-40" @click="closeMenu"></div>
      </div>
    </div>

    <!-- ═══ СТРОКА 2: Категории объявлений (только desktop) ═══ -->
    <div class="hidden md:block border-t border-gray-100 dark:border-gray-700">
      <div class="max-w-7xl 2xl:max-w-[1536px] mx-auto px-4">
        <ul class="flex flex-row items-center justify-center">
          <li>
            <router-link :to="routePath('VACANCIES', '/vacancy')" class="menu-link" @click="closeMenu">
              <span>Вакансии</span></router-link>
          </li>
          <li>
            <router-link :to="routePath('RESUMES', '/resume')" class="menu-link" @click="closeMenu"><span>Резюме</span>
            </router-link>
          </li>
          <li>
            <router-link :to="routePath('OFFERINGS', '/offering')" class="menu-link" @click="closeMenu">
              <span>Услуги</span></router-link>
          </li>
          <li>
            <router-link :to="routePath('REALTY', '/realty')" class="menu-link" @click="closeMenu">
              <span>Недвижимость</span></router-link>
          </li>
          <li>
            <router-link :to="routePath('PRODUCTS', '/product')" class="menu-link" @click="closeMenu">
              <span>Товары</span></router-link>
          </li>
          <li>
            <router-link :to="routePath('QUICK_POST_LIST', '/quick-posts')" class="menu-link" @click="closeMenu">
              <span>Быстрые объявления</span></router-link>
          </li>
        </ul>
      </div>
    </div>

    <BaseModal
        v-model="showNotificationModal"
        overlayClass="bg-black bg-opacity-80 z-50"
        title="Уведомления"
        modal-class="w-full max-w-2xl max-h-[80vh] overflow-y-auto"
    >
      <template #header-action></template>
      <NotificationModal ref="notificationModalRef" @close="showNotificationModal = false"/>
    </BaseModal>
  </header>
</template>

<script>
import {useAuthStore} from "@/store/authStore.js";
import {useThemeStore} from "@/store/themeStore.js";
import {useUserStore} from "@/modules/user/store/userStore.js";
import {CHAT_ENABLED} from '@/modules/profile/store/chatStore.js';
import {ROUTES, useNavigation} from "@/router";
import ThemeToggle from "@/core/components/material/v1/header/ThemeToggle.vue";
import ExitSvg from "@/core/components/svg_components/ExitSvg.vue";
import ProfileSvg from "@/core/components/svg_components/ProfileSvg.vue";
import FavoritesSvg from "@/core/components/svg_components/FavoritesSvg.vue";
import ChatIconWithBadge from "@/modules/profile/components/ChatIconWithBadge.vue";
import NotificationIcon from "@/assets/icons/notification-icon.svg";
import {computed, onMounted, ref} from "vue";
import NotificationModal from "@/core/components/material/v1/modal/NotificationModal.vue";
import {useUserNotificationStore} from "@/modules/user_notification/store/userNotificationStore.js";
import {useSupportStore} from "@/modules/support/store/supportStore.js";
import BaseModal from "@/core/components/material/v1/modal/BaseModal.vue";

export default {
  components: {
    BaseModal,
    NotificationModal,
    ChatIconWithBadge,
    FavoritesSvg,
    ProfileSvg,
    ExitSvg,
    ThemeToggle,
    NotificationIcon,
  },
  setup() {
    const {routes: navRoutes} = useNavigation();
    const routes = {
      ...ROUTES,
      PRODUCTS: ROUTES.PRODUCTS || {path: "/product", name: "ProductsPage"},
      ...navRoutes,
    };

    const routePath = (key, fallback) => routes?.[key]?.path || fallback;
    const myOfferingsRoute = computed(() => ({
      name: routes.PROFILE_MY_LISTINGS?.name || 'MyListingsPage',
    }));
    const myProductsRoute = computed(() => ({
      name: routes.PROFILE_MY_PRODUCTS?.name || 'MyProductsPage',
    }));

    const authStore = useAuthStore();
    const themeStore = useThemeStore();
    const userStore = useUserStore();

    const showNotificationModal = ref(false);
    const notificationModalRef = ref(null);
    const userNotificationStore = useUserNotificationStore();
    const unreadCount = computed(() => userNotificationStore.unreadCount);

    const supportStore = useSupportStore();
    const supportUnreadCount = computed(() => supportStore.unreadCount);

    async function markAllRead() {
      await userNotificationStore.markAllAsRead();
      notificationModalRef.value?.onAllMarkedRead?.();
    }

    onMounted(async () => {
      try {
        if (authStore.isAuthenticated) {
          await userNotificationStore.fetchUnreadCount();
          await supportStore.fetchUnreadCount();
          if (authStore.userId) {
            await userStore.fetchById(authStore.userId, {target: 'current'});
          }
        }
      } catch (error) {
        console.error('Header mount error:', error);
      }
    });

    return {
      themeStore,
      authStore,
      userStore,
      routes,
      routePath,
      myOfferingsRoute,
      myProductsRoute,
      unreadCount,
      supportUnreadCount,
      showNotificationModal,
      notificationModalRef,
      markAllRead,
      CHAT_ENABLED,
    };
  },
  data() {
    return {
      isMenuOpen: false,
      menuVisibility: {
        management: false,
        account: false,
      },
    };
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    closeMenu() {
      this.isMenuOpen = false;
    },
    logout() {
      this.authStore.logout();
      this.closeMenu();
    },
    showMenu(menuName) {
      this.menuVisibility[menuName] = true;
    },
    hideMenu(menuName) {
      this.menuVisibility[menuName] = false;
    },
    toggleTheme() {
      if (this.themeStore) this.themeStore.toggleTheme();
      this.closeMenu();
    },
  },
};
</script>

<style scoped>
.material-header {
  @apply bg-white dark:bg-gray-800 text-gray-800 dark:text-gray-200;
}

/* Верхняя строка: логотип | навигация | аккаунт */
.top-row {
  /* переопределяем старый .container */
}

.menu {
  @apply hidden md:flex;
  transition: all 0.3s ease-in-out;
}

.menu-open {
  @apply fixed inset-0 bg-white dark:bg-gray-900 z-50 flex flex-col p-6;
  animation: slide-down 0.3s ease-in-out;
}

.close-button {
  @apply self-end p-2 rounded-full transition-all focus:outline-none;
}

.close-button svg {
  @apply w-6 h-6 text-gray-800 dark:text-gray-200;
}

.nav-link {
  @apply w-full px-3 py-2.5 rounded-md text-base font-medium text-gray-700 dark:text-gray-300
  transition-all duration-200 hover:bg-gray-100 hover:text-indigo-600
  dark:hover:bg-gray-700 dark:hover:text-indigo-400;
}

@media (min-width: 1280px) {
  .nav-link {
    padding-top: 0.375rem;
    padding-bottom: 0.375rem;
    font-size: 14px;
  }
}

/* Ссылки верхней строки (Новости и будущие) */
.top-nav-link {
  @apply flex items-center px-4 py-2 rounded-lg text-base font-semibold
  text-gray-700 dark:text-gray-200
  hover:bg-indigo-50 hover:text-indigo-600
  dark:hover:bg-indigo-900/30 dark:hover:text-indigo-400
  transition-colors duration-200;
}

@media (min-width: 1280px) {
  .top-nav-link {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
    font-size: 14px;
  }
}

/* router-link-active для top-nav-link */
.top-nav-link.router-link-active {
  @apply text-indigo-600 dark:text-indigo-400 bg-indigo-50 dark:bg-indigo-900/30;
}

.menu-button {
  @apply p-2 rounded-full transition-all duration-200 ml-auto block md:hidden
  bg-gray-50 dark:bg-gray-800 hover:bg-gray-100 dark:hover:bg-gray-700
  focus:ring-2 focus:ring-indigo-400 focus:outline-none;
}

.menu-button svg {
  @apply transition-transform duration-300;
}

.menu-open .menu-button svg {
  transform: rotate(90deg);
}

.menu-overlay {
  @apply block;
}

@keyframes slide-down {
  from {
    transform: translateY(-100%);
  }
  to {
    transform: translateY(0);
  }
}

.theme-toggle-button {
  @apply self-end p-2 rounded-full transition-all duration-200;
}

.menu-link {
  @apply nav-link flex cursor-pointer;
}

.header-icon {
  @apply flex items-center justify-center w-10 h-10 rounded-full transition-colors duration-200;
  @apply hover:bg-gray-100 dark:hover:bg-gray-700;
  @apply text-gray-700 dark:text-gray-300 hover:text-indigo-600 dark:hover:text-indigo-400;
}

/* Кнопка онбординга — в группе иконок, вертикально выровнена автоматически */
.onboarding-btn {
  @apply flex items-center justify-center w-10 h-10 rounded-full transition-transform duration-150;
}

.onboarding-btn svg {
  filter: drop-shadow(0 1px 4px rgba(22, 163, 74, 0.35));
  transition: filter 0.15s ease;
}

.onboarding-btn:hover {
  transform: scale(1.12);
}

.onboarding-btn:hover svg {
  filter: drop-shadow(0 2px 10px rgba(22, 163, 74, 0.55));
}


/* Пробиваем scoped-границу для SVG-файлов (NotificationIcon) */
.header-icon :deep(.icon-svg) {
  @apply w-6 h-6;
}

.header-icon :deep(.icon-svg path),
.header-icon :deep(.icon-svg circle),
.header-icon :deep(.icon-svg rect) {
  fill: currentColor;
}
</style>
